export function flattenAttributes(attributes, prefix = "") {
  const result = {};
  for (const [key, value] of Object.entries(attributes)) {
    if (value === void 0 || value === null) continue;
    const keySegment = key.toLowerCase();
    const fullKey = prefix ? `${prefix}_${keySegment}` : keySegment;
    if (typeof value === "object" && !Array.isArray(value)) {
      Object.assign(
        result,
        flattenAttributes(value, fullKey)
      );
    } else if (Array.isArray(value)) {
      result[fullKey] = value.join(",");
    } else {
      result[fullKey] = typeof value === "string" ? value : JSON.stringify(value);
    }
  }
  return result;
}
